/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'

const Footer = () => {
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
      <div className='text-dark order-2 w-100 d-flex justify-content-between   order-md-1 w-100'>
        <span className='text-gray-800 text-hover-primary'>
          Bapenda LAB. Batu
        </span>
        <div>
          <span className='text-muted fw-semibold me-1'>
            Copyright {new Date().getFullYear().toString()}&copy;
          </span>
          <span className='text-gray-800 text-hover-primary'>Infotek Metro Data</span>
        </div>
      </div>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}